export default __webpack_public_path__ + "static/media/Bracers of Necrotic Dread.fd9b5c46.jpg";